import { render, staticRenderFns } from "./BookingConfirmation.vue?vue&type=template&id=89ade1d0&scoped=true"
import script from "./BookingConfirmation.vue?vue&type=script&lang=js"
export * from "./BookingConfirmation.vue?vue&type=script&lang=js"
import style0 from "./BookingConfirmation.vue?vue&type=style&index=0&id=89ade1d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89ade1d0",
  null
  
)

export default component.exports